import React from 'react'
import { BuildPath } from '../../../helpers/Paths'



const InsightHighlightsGridItem = ({value, icon, name}: {value: number, icon:string | React.ReactNode, name:string}) => {

    function renderIcon() {
        if (typeof icon === 'string') {
            return <img className={`${name}-icon`} alt={name} src={`${BuildPath()}/images/insight_highlight_icons/${icon}`}/>
        } else {
            return icon;
        }
    };

    function valueText() {
        if (isNaN(value)){
            return 'n/a'
        }

        const oneMillion = 1000000;
        const oneThousand = 1000;

        switch(true) {
            case value >= oneMillion:
              return `${Math.round(value / oneMillion * 10) / 10}m`
            
            case value >= oneThousand:
              return `${Math.round(value / oneThousand * 10) / 10}k`
          
            default:
              return value
        }
    }

    return(
        <section>
            <h1>{valueText()}</h1>
            
            <div className='text-container'>
                {renderIcon()}
                <p>{name}</p>
            </div>
        </section>
    )
}

export default InsightHighlightsGridItem